export class TableObjectsEvents
{
    static UPDATED: string =  'TableObjectsEvents.UPDATED';
}
